import React from 'react'
import { useRef } from 'react'

const FormSelectSeller = ({Lable,Value,setValue,Options}) => {
    const selectBox = useRef(null);
    function Toggle(){
        if(selectBox.current.className.includes('active')){
            selectBox.current.className = 'form_select_wrapper';
        }
        else{
            selectBox.current.className = 'form_select_wrapper active';
        }
    }
  return (
    <div className='form_select_main_container'>
        <label>{Lable}</label>
        <div ref={selectBox} className='form_select_wrapper' onClick={Toggle}>
            <div className='form_select_container'>
                <div className='form_select_value'>
                    <h6>{Value.username}</h6>
                </div>
                <div className='form_select_options'>
                    {
                        Options.map((item,index)=>{
                            return(
                                <div className='form_select_option' onClick={()=>{setValue(item)}} key={index}>
                                    <h6>{item.username}</h6>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    </div>
  )
}

export default FormSelectSeller
